export const FETCH_MAIL = "FETCH_MAIL";
export const fetchMail = (box = "inbox", options = {}) => async (dispatch) => {
    return dispatch({
        type: FETCH_MAIL,
        box,
    });
};
